import { toast } from "react-toastify";
import { call, fork, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllPayments({ payload }) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.getAllPayments);
    yield put(actions.getAllPaymentsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllPaymentsFail());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}

function* getPaymentException({ payload }) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.getPaymentException);
    yield put(actions.getPaymentExceptionSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getPaymentExceptionFail());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}

//Edit Tables
function* editPayment(data) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.editPayments, data.payload);
    yield put(actions.editPaymentSuccess(result.data));
    toast.success("Edit Successfully");
    data?.action && data?.action();
  } catch (error) {
    yield put(actions.editPaymentFail());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}

// create
function* createPayment(formData) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.createPayments, formData.payload);
    yield put(
      actions.createPaymentSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action();
  } catch (error) {
    yield put(actions.createPaymentFail());
    toast.success(error.data.message.toString());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}

function* deletePayment({ payload }) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.deletePayment, payload);

    yield put(actions.deletePaymentSuccess(payload));

    toast.success("Deleted Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.deletePaymentFail());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}

function* createVoucher({ payload }) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.createVoucher, payload);
    yield put(actions.createVoucherSuccess(payload));
    toast.success("Done Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.createVoucherFail());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}

// Student Payments
function* getStudentPayments({ payload }) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.listAllStudentPAyment, payload);
    yield put(actions.getStudentPaymentsSuccess(result));
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response?.data?.message || "Failed to fetch student payments");
    yield put(actions.getStudentPaymentsFail());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}

function* editStudentPayment({ payload }) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.editStudentPayment, payload.id, payload.formData);
    // yield put(actions.editStudentPaymentSuccess({ data: result.data }));
    toast.success("Student payment updated successfully");
    payload?.action && payload?.action();
  } catch (error) {
    toast.error(error);
    yield put(actions.editStudentPaymentFail());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}

function* deleteStudentPayment({ payload }) {
  try {
    yield put(actions.addPaymentLoading(true));
    const result = yield call(api.deleteStudentPayment, payload);
    yield put(actions.deleteStudentPaymentSuccess(payload));
    toast.success("Student payment deleted successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response?.data?.message || "Failed to delete student payment");
    yield put(actions.deleteStudentPaymentFail());
  } finally {
    yield put(actions.addPaymentLoading(false));
  }
}
export default function* PaymentSaga() {
  yield takeLatest(Types.GET_PAYMENTS_REQUEST, getAllPayments);
  yield takeLatest(Types.GET_PAYMENT_EXCEPTION_REQUEST, getPaymentException);

  yield takeLatest(Types.EDIT_PAYMENT_REQUEST, editPayment);
  yield takeLatest(Types.CREATE_PAYMENT_REQUEST, createPayment);
  yield takeLatest(Types.DELETE_PAYMENT_REQUEST, deletePayment);
  yield takeLatest(Types.CREATE_VOUCHER_REQUEST, createVoucher);

  // Student Payments
  yield takeLatest(Types.GET_STUDENT_PAYMENTS_REQUEST, getStudentPayments);
  yield takeLatest(Types.EDIT_STUDENT_PAYMENT_REQUEST, editStudentPayment);
  yield takeLatest(Types.DELETE_STUDENT_PAYMENT_REQUEST, deleteStudentPayment);
}
